// extracted by mini-css-extract-plugin
module.exports = {"staticButton":"TestMarkingLegend_staticButton__7mxXs"};